import { styled, Theme } from '@material-ui/core';
import { Button } from 'src/modules/shared/components';

export const DifferentiationListWrapper = styled('div')<Theme>(({ theme }) => ({
  border: '1px solid #EAE6DC',
  borderRadius: `${theme.config.defaultBorderRadius} ${theme.config.defaultBorderRadius} 0px 0px`,
  '&.selected': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  '&:hover': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  cursor: 'pointer'
}));

export const DifferentiationListItemWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  width: '100%',
  flexGrow: 1,
  padding: theme.spacing(2),
  gap: theme.spacing(0.25),
}));

export const DifferentiationListItemHeaderWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  minHeight: '2rem',
  gap: theme.spacing(1),
}));

export const DifferentiationListItemTitle = styled('input')<Theme>(({ theme }) => ({
/*   height: '2rem', */
  width: '100%',
  border: 'none',
  outline: 'none',
  fontWeight: 600,
  textAlign: 'left',
  margin: 0,
  padding: 0,
  color: theme.palette.offblack,
  fontSize: "16px",
  backgroundColor: theme.palette.common.white,
  '&:not(.disabled)': {
    cursor: 'pointer',
  },
  '&.disabled)': {
    border: theme.config.defaultBorder(),
    backgroundColor: theme.config.appbarColors.background,
  },
  '&:not(.disabled):focus': {
    border: theme.config.defaultBorder(),
    backgroundColor: theme.config.appbarColors.background,
  },
  '&.current': {
    color: theme.palette.primary.main,
  },
}));

export const DifferentiationTitle = styled('h2')<Theme>(({theme}) => ({
  fontWeight: 600,
  width: '100%',
  textAlign: 'left',
  margin: 0,
  padding: 0,
  color: theme.palette.offblack,
  fontSize: "16px",
  cursor: 'text',
  '&:not(.disabled):hover': {
    border: theme.config.defaultBorder(),
    backgroundColor: theme.config.appbarColors.background,
  },
  '&.current': {
    color: theme.palette.primary.main,
  },
}));

export const DifferentiationListItemSubheader = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: theme.spacing(0.25),
  color: theme.palette.secondary.main,
  marginTop: '4px',
  padding: 0,
  fontSize: '14px',
  '& p': {
    margin: 0,
  },
}));

export const DifferentiationListItemFooterWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  bottom: 0,
  left: 0,
  height: '31px',
  padding: theme.spacing(1),
  justifyContent: 'space-between',
  backgroundColor: theme.config.appbarColors.background,
  alignItems: 'center',
  width: '100%',
}));

export const FooterSwitchWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0),
  '&.is-hidden': {
    visibility: 'hidden',
  },
  '& span': {
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    fontWeight: 400,
    fontSize: 14,
  },
}));

export const DifferentiationListItemFooterButtonsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DifferentiationListItemFooterDeleteButton = styled('button')<Theme>(({ theme }) => ({
  outline: 'none',
  border: 'none',
  marginRight: theme.spacing(0.75),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  height: '30px',
  '&.hide-button': {
    display: 'none',
  },
}));

export const DifferentiationListItemFooterButton = styled(Button)<Theme>(({ theme }) => ({
  height: '20px',
  '&.hide-button': {
    visibility: 'hidden',
  },
}));

export const AssignToGroupsAction = styled('button')<Theme, {hasGroups: boolean}>(({ theme, hasGroups }) => ({
  outline: 'none',
  border: hasGroups ? 0 : `1px solid ${theme.palette.primary.main}`,
  color: hasGroups ? 'black' : 'hsla(20, 74%, 42%, 1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  whiteSpace: 'nowrap',
  backgroundColor: hasGroups ? 'transparent' : 'hsla(20, 84%, 53%, 0.2)',
  gap: theme.spacing(0.5),
  textAlign: 'left',
  borderRadius: '2px',
  padding: theme.spacing(0.25),
  marginTop: theme.spacing(0.5),
  cursor: 'pointer',
  '&.is-assigned': {
    border: 'none',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    '& span': {
      display: 'flex',
      gap: theme.spacing(0.5),
      margin: 0,
      borderBottom: '1px solid black',
    },
  },
}));

export const GroupMessageWrapper = styled('span')<Theme>(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '2px',
}));

